module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Gb-Hc-Ib-Jb.c2ff3a02.png";